export const TOGGLE_CHHOSE_RELATIVE_MODAL = "TOGGLE_CHHOSE_RELATIVE_MODAL";
export const TOGGLE_CONFIRM_RELATIVE_MODAL = "TOGGLE_CONFIRM_RELATIVE_MODAL";
export const TOGGLE_REDIRECT_APP_MODAL = "TOGGLE_REDIRECT_APP_MODAL";
